module.exports = __webpack_public_path__ + "static/media/vance.a6cea21b.png";